export const SEARCH = "Search"
export const HOME = "Homepage"
export const CATEGORY = "Category"
export const PERK = "Perk"

export const PAGES = [SEARCH, HOME, CATEGORY, PERK]

export default {SEARCH, HOME, CATEGORY, PERK, PAGES}
